import React from 'react'
import Header from 'semantic-ui-react/dist/commonjs/elements/Header'

export default () => <Header as="h2">Settings:</Header>
